import {useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import { Box, Collapse, IconButton,
    LinearProgress, Paper, Table,
    TableBody, TableCell, TableContainer,
    TableHead, TableRow, Tooltip,
} from '@material-ui/core';
import qs from 'qs';
import moment from 'moment';
import {ErrorGeneral, llamadaApiToken} from '../funciones/ClienteAxios';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import LocationOnIcon from "@material-ui/icons/LocationOn";
import ModalMapa from "./ModalMapa";
import CreateIcon from '@material-ui/icons/Create';
import ModalEditRecorrido from './ModalNvoEdit';
const useStyles = makeStyles(theme=>({
    container: {
        maxHeight: window.innerHeight - 170,
        minHeight: 280,
        minWidth: '100%',
    },
    container2: {
        maxHeight: 550,
    },
    tableRow: {
        "&$selected, &$selected:hover": {
            backgroundColor: theme.palette.secondary.main
        }
    },
    tableCell: {
        "$selected &": {
            color: "white"
        }
    },
    hover: {},
    selected: {}
}));

export default function TablaRecorridos({ history, fechasSeleccionadas, source,
                                            idusu, buscar, checked,
                                            abrirModal, setAbrirModal,
                                            setRecorrido, Distrito, tipo,
                                            latitud,longitud
                                        }) {
    const classes = useStyles();
    const [espera, setEspera] = useState(false);
    const [datos, guardarDatos] = useState([])
    const [sinDatos, guardarSinDatos] = useState(true)
    const [open, setOpen] = useState(false);
    const [actualizar, setActualizar] = useState(false);
    const [modalEdit, setModalEdit] = useState(false);
    const [seleccionado, setSeleccionado] = useState([]);
    
    let filter = 0


    useEffect(() => {
        const llenarTabla = () => {
            setEspera(true)
            const fInicio = moment(fechasSeleccionadas.inicio).format("YYYY-MM-DD")
            const fFinal = moment(fechasSeleccionadas.final).format("YYYY-MM-DD")
            const data = qs.stringify({
                Usuario: idusu,
                //Filtro: 0,
                Distrito:Distrito.length!==0 ? Distrito:0,
                Tipo:tipo.length!==0 ? tipo:0,
                Fini: fInicio + 'T00:00:00',
                Ffin: fFinal + 'T23:59:59',
                idDispositivo: '45vf2d1vdf21d2f'
            });
            const url = "recorrido/v3/list";

            function response(data) {
                if (data[0].Id != -1) {
                    guardarSinDatos(true)
                    guardarDatos(data)
                    if (seleccionado.length!==0) {
                        const filtro = data.filter((regis)=> regis.Id ===seleccionado.Id)
                        //console.log(filtro);
                        if (filtro[0].length!==0) {                                                        
                            setSeleccionado(filtro[0])
                            setRecorrido(filtro[0])
                        }
                    }
                    setEspera(false)
                } else {
                    guardarSinDatos(false)
                    setEspera(false)
                }
            }

            llamadaApiToken(data, url, response, ErrorGeneral, history, source);
        };

        llenarTabla();
    }, [buscar,actualizar]);

    const seleccionar = (auxId, auxOrden) => {
 
        setRecorrido(auxOrden)
        setSeleccionado(auxOrden)
    }

    const abrirModalMapa = () => {
        setAbrirModal(true)
    }

    const celda = (alinear, estilo, contenido,index) => {
        return (
        <TableCell align={alinear} key={index} className={classes.tableCell} 
            padding={'none'} style={estilo} >
            {contenido}
        </TableCell>)
    }
        


    const modalMapa = abrirModal ? <ModalMapa abrirModal={abrirModal}
                                        setAbrirModal={setAbrirModal}  datos={seleccionado}
                                    /> : null
    
    function verMas(auxId) {
        setSeleccionado(auxId)
        if (auxId === seleccionado.Id ) {
            setOpen(!open)
        } else {
            setOpen(false)
        }
    }

    function Row(props) {
        const {row} = props;
        const auxVal=seleccionado?.Id === row.Id ?true:false
        
        return (
        <>
            <TableRow onClick={() => { seleccionar(row.Id, row) }}
                className={classes.tableRow} selected={seleccionado?.Id === row.Id}
                classes={{hover: classes.hover, selected: classes.selected}}
            >                                       
                {/* <TableCell align="center" padding={'none'} style={{width: 30}}>
                    {row.Obsrv.length !== 0 ?
                        <Tooltip title={open && seleccionado?.Id  === row.Id ? 'Ver menos' : 'Ver más'}>
                            <IconButton color="primary" aria-label="expand row" size="small"
                                onClick={() => verMas(row.Id)}>
                                {open && seleccionado?.Id  === row.Id ?
                                    (seleccionado?.Id  === row.Id ?
                                        <KeyboardArrowUpIcon style={{color: 'white'}}/>
                                        : <KeyboardArrowUpIcon/>)
                                    : (seleccionado?.Id  === row.Id ?
                                        <KeyboardArrowDownIcon style={{color: 'white'}}/>
                                        : <KeyboardArrowDownIcon/>)}
                            </IconButton>
                        </Tooltip>
                        : null}
                </TableCell> */}
                { celda("center", {width:"1.5rem"}, 
                    <Tooltip title={`Editar `}>
                    <IconButton aria-label="editar registro" onClick={() => setModalEdit(true)} 
                        component="span" size="small" 
                    >
                        <CreateIcon style={{color:auxVal? "white":"" }} color={auxVal? "inherit":"primary" } />  
                    </IconButton>
                    </Tooltip> 
                , seleccionado?.Id+4)   }  
                {row.Lat && row.Lon !== 0.0 ?
                    <TableCell align="center" padding={'none'} style={{width: 30}}>
                        <Tooltip title={'Ver más'}>
                            <IconButton color="primary" size="small"
                                onClick={() => abrirModalMapa()}>
                                {seleccionado?.Id === row.Id ?
                                    <LocationOnIcon style={{color: 'white'}}/> 
                                    : <LocationOnIcon/>}
                            </IconButton>
                        </Tooltip>
                    </TableCell> 
                    : <TableCell align="center" padding={'none'} style={{width: 30}}></TableCell>
                }

                
                <TableCell className={classes.tableCell} align="center" padding={'none'} width={75}
                    style={{fontSize: 12 + 'px'}} >
                    {moment.utc(row.FEnv).local(true).format("DD/MM/YYYY HH:mm")}
                </TableCell>
                 <TableCell className={classes.tableCell} align="left" padding={'none'} width={90}
                    style={{fontSize: 12 + 'px', paddingLeft:"15px"}} >
                    {row.UsrNom}
                </TableCell>
                <TableCell className={classes.tableCell} align="center" padding={'none'} width={60}
                    style={{fontSize: 10 + 'px'}} >
                    {row.DtoNom}
                </TableCell>
                <TableCell className={classes.tableCell} align="center" padding={'none'} width={60}
                    style={{fontSize: 10 + 'px'}} >
                    {row.SeccNom}
                </TableCell>
                <TableCell className={classes.tableCell} align="left" padding={'none'} width={90} style={{paddingLeft:".1rem"}}>
                    {row.TipoNom}
                </TableCell>
                <TableCell className={classes.tableCell} align="center" padding={'none'} width={60}
                    style={{fontSize: 12 + 'px'}} >
                    {row.Cantidad}
                </TableCell>
               <TableCell className={classes.tableCell} align="left" padding={'none'} width={120}
                    style={{fontSize: 12 + 'px'}} >
                     {row.Obsrv}
                </TableCell>
      
                <TableCell className={classes.tableCell} align="left" padding={'none'} style={{fontSize: 12 + 'px'}}
                     width={120}>
                    {row.Direcc.length!==0 && row.Direcc.length>25? `${row.Direcc.substring(0,25)}...` : row.Direcc}
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={9}>
                    <Collapse in={open && seleccionado?.Id  === row.Id && row.Obsrv.length !== 0} timeout="auto"
                        unmountOnExit>
                        <Box margin={1}>
                        <Table size="small" aria-label="purchases">
                            <TableHead>
                                <TableRow>
                                    <TableCell padding={'none'}> Observación </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow key={row.Id}>
                                    <TableCell padding={'none'}> {row.Obsrv}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
        );
    }

    function tablaCompleta(auxlista) {
        return (
        <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
            <TableHead>
                <TableRow>
                    <TableCell align="center" padding='none'></TableCell> 
                    <TableCell align="center" padding='none'>{auxlista.length}</TableCell>                            
                    <TableCell align="center" padding='none'>Fecha Registro</TableCell>
                    <TableCell align="center" padding='none'>Usuario</TableCell>
                    
                    <TableCell align="center" padding='none'>Distrito</TableCell>
                    <TableCell align="center" padding='none'>Sección</TableCell>
                    <TableCell align="center" padding='none'>Tipo</TableCell>
                    <TableCell align="center" padding='none'>Cantidad</TableCell>
                    {/* <TableCell align="center" padding='none'>Estado</TableCell> */}
                    <TableCell align="center" padding='none'>Observación</TableCell>
                    {/* <TableCell align="center" padding='none'>Sección</TableCell> */}
                    <TableCell align="center" padding='none'>Dirección</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {auxlista.length != 0 ? (auxlista.map((row) => (
                    <Row key={row.Id} row={row}/>
                ))) : null}
            </TableBody>
        </Table>
        </TableContainer>
        )
    }

    const tablaSinDatos = () => {
        return (
            <TableContainer className={classes.container2}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" padding='none'></TableCell>
                            <TableCell align="center" padding='none'>Fecha Sistema</TableCell>
                            <TableCell align="center" padding='none'>Fecha Registro</TableCell>
                            <TableCell align="center" padding='none'>Nombre</TableCell>
                            <TableCell align="center" padding='none'>Tipo</TableCell>
                            <TableCell align="center" padding='none'>Estado</TableCell>
                            <TableCell align="center" padding='none'>Municipio</TableCell>
                            <TableCell align="center" padding='none'>Sección</TableCell>
                            <TableCell align="center" padding='none'>Dirección</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow className={classes.tableRow}>
                            <TableCell className={classes.tableCell} align="center">Dia</TableCell>
                            <TableCell className={classes.tableCell} align="left">Sin</TableCell>
                            <TableCell className={classes.tableCell} align="left">Recorridos</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }

    const modEdit = modalEdit ? <ModalEditRecorrido abrirModal={modalEdit} setAbrirModal={setModalEdit} idusu={idusu}  latitud={latitud} longitud={longitud} 
                                    actualiza={()=>setActualizar(!actualizar)} auxRegistro={seleccionado} /> : null
    const contenido = sinDatos && datos.length != 0 ? tablaCompleta(datos) : tablaSinDatos()
    const tabla = espera ? (<Box mt={2}><LinearProgress/> </Box>) : (contenido)

    return (
    <Paper>
        {modEdit}
        {tabla}
        {modalMapa}
    </Paper>
    );
}